import React from "react";
import {
  HeaderConfig,
  IntroContentConfig,
  IntroThemeConfig,
  appleAppStoreLink,
  appliedConfig,
  googlePlayStoreLink,
} from "../config/commonConfig";
const AboutUs = () => {
  return (
    <section
      id="about"
      className={
        "section " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }
    >
      <div
        className={
          "container " +
          (appliedConfig.appliedIntro === IntroThemeConfig.Intro1 &&
          appliedConfig.appliedIntroContent === IntroContentConfig.Image
            ? "pt-5 "
            : " ")
        }
      >
        <h2 className="text-9 fw-600 text-center">Sobre o Sistema Integrare</h2>
        <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
        <p className="lead text-center mb-4">
          Gestão de agências completa em uma única plataforma integrada
        </p>
        <div className="row">
          <div className="col-lg-6 text-center">
            {" "}
            <img className="img-fluid" src="images/about-app.png" alt="Sistema Integrare" />{" "}
          </div>
          <div className="col-lg-6 text-center text-lg-start">
            <h2 className="text-6 mb-3 mt-4">
              Transforme sua Gestão de Agência
            </h2>
            <p>
              O Integrare é uma plataforma completa que unifica CRM, gestão de projetos, 
              controle financeiro e automação em um sistema integrado. Nossa solução 
              foi desenvolvida para agências que buscam eficiência e resultados.
            </p>
            <p>
              Com automação N8N integrada, conectamos todos os seus processos, 
              eliminando retrabalho e automatizando fluxos complexos para 
              acelerar o crescimento da sua agência.
            </p>
            <div className="d-inline-flex pt-2">
              <a
                className="btn btn-primary me-3 px-4"
                href="/auth/register"
                title="Criar Conta"
              >
                Criar Conta
              </a>
              <a
                className="btn btn-outline-primary px-4"
                href="/auth/login"
                title="Fazer Login"
              >
                Fazer Login
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
